import { Box } from '@veracity/vui'

import { PageContainer, PageSearchInput } from '@/components'
import { useCurrentUser, useFilterDatasets } from '@/hooks'

import {
  AddLossFactorsDatasetDialog,
  LossFactorsDatasetsTable
} from './components'
import { useLossFactors } from './hooks'

export const LossFactorsPage = () => {
  const { isUser } = useCurrentUser()
  const { lossFactorsDatasets, isFetching } = useLossFactors()

  const { filteredDatasets, onFilterChange } =
    useFilterDatasets(lossFactorsDatasets)

  return (
    <PageContainer
      loading={isFetching}
      header={
        <PageContainer.Breadcrumbs
          items={[{ title: 'Library' }, { title: 'Loss Factors' }]}
        />
      }
      menuBar={
        <Box justify="space-between" w="100%">
          <PageSearchInput onChange={onFilterChange} />
          {isUser && <AddLossFactorsDatasetDialog />}
        </Box>
      }>
      <LossFactorsDatasetsTable datasets={filteredDatasets} />
    </PageContainer>
  )
}
